var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90918 12L10.9092 14L15.4092 9.5M7.24295 3.8187C8.04678 3.75455 8.80989 3.43846 9.42365 2.91542C10.8559 1.69486 12.9625 1.69486 14.3947 2.91542C15.0085 3.43846 15.7716 3.75455 16.5754 3.8187C18.4512 3.96839 19.9408 5.45794 20.0905 7.33377C20.1546 8.1376 20.4707 8.90071 20.9938 9.51447C22.2143 10.9467 22.2143 13.0533 20.9938 14.4855C20.4707 15.0993 20.1546 15.8624 20.0905 16.6662C19.9408 18.5421 18.4512 20.0316 16.5754 20.1813C15.7716 20.2455 15.0085 20.5615 14.3947 21.0846C12.9625 22.3051 10.8559 22.3051 9.42365 21.0846C8.80989 20.5615 8.04678 20.2455 7.24295 20.1813C5.36712 20.0316 3.87757 18.5421 3.72787 16.6662C3.66373 15.8624 3.34764 15.0993 2.8246 14.4855C1.60404 13.0533 1.60404 10.9467 2.8246 9.51447C3.34764 8.90071 3.66373 8.1376 3.72787 7.33377C3.87757 5.45794 5.36712 3.96839 7.24295 3.8187Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.679ed62b541e39e2662b253bcfd897d0.svg";
export { ForwardRef as ReactComponent };